exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".closable-overlay__background-overlay__3XGbj,.closable-overlay__content__3Y1RC,.closable-overlay__overlay__1466f{position:absolute;top:0;left:0;right:0;bottom:0}.closable-overlay__overlay__1466f{z-index:10}.closable-overlay__close__1rl6s{position:absolute;z-index:2;top:32px;right:32px;overflow:hidden;color:#fff;font-size:12px;cursor:pointer}.closable-overlay__close__1rl6s:hover{opacity:.6}@media (max-width:549px){.closable-overlay__close__1rl6s{top:20px;right:20px}}.closable-overlay__content__3Y1RC{z-index:1;color:#fff;background-color:rgba(0,0,0,.8)}", ""]);

// exports
exports.locals = {
	"background-overlay": "closable-overlay__background-overlay__3XGbj",
	"backgroundOverlay": "closable-overlay__background-overlay__3XGbj",
	"content": "closable-overlay__content__3Y1RC",
	"overlay": "closable-overlay__overlay__1466f",
	"close": "closable-overlay__close__1rl6s"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/compact/components/closable-overlay/closable-overlay.styl
// module id = 2938
// module chunks = 1